import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const VolleyballColored = ({ size = 'xsmall' }: IconProps) => {
    return (
        <svg width={IconSizes[size]} height={IconSizes[size]} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g id="Volleyball" fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    fill="#BB45FF"
                    d="m4.007 5.21 3.192-3.121L12.556 1l4.173 1.089 1.218 1.016-1.798 4.737-5.094-1.767-3.492-.865z"
                />
                <path
                    fill="#BB45FF"
                    d="m12 12.262 1.506 5.105 1.806-.452 3.793-3.876 2.489-5.348-1.056-2.138-2.197-2.527-1.544 3.596-2.15 3.574zM10.356 23l-3.889-1.202L3.084 18.2 1.49 15.031 1 11.731l2.672-1.073 2.795.327.452 5.076 1.317 3.362 1.698 2.375z"
                />
                <path
                    d="M17.12 19.393a10.895 10.895 0 0 1-2.16-2.221 16.935 16.935 0 0 0 5.849-7.014 8.992 8.992 0 0 1-3.689 9.235m-14.097-6.95a10.862 10.862 0 0 1 2.81-.626 16.944 16.944 0 0 0 2.954 8.58 9.003 9.003 0 0 1-5.764-7.954M16.207 4.05a10.912 10.912 0 0 1-.898 2.755 16.947 16.947 0 0 0-8.757-1.951 8.937 8.937 0 0 1 9.655-.804M4.442 7.132a14.925 14.925 0 0 1 9.814 1.383 10.982 10.982 0 0 1-2.361 2.334c-.016 0-.03-.006-.046-.005-.006 0-.01.004-.016.005a12.923 12.923 0 0 0-8.665-.56 8.933 8.933 0 0 1 1.274-3.157m7.37 13.859a14.912 14.912 0 0 1-3.971-9.143c1.097.113 2.178.395 3.213.839.45 2.989 1.905 5.717 4.137 7.718A8.925 8.925 0 0 1 12 21c-.063 0-.125-.008-.188-.01M19.71 7.384a14.91 14.91 0 0 1-5.76 8.053 10.962 10.962 0 0 1-.908-2.952 12.922 12.922 0 0 0 4.938-7.191 9.061 9.061 0 0 1 1.73 2.09M12 1C5.935 1 1 5.935 1 12c0 6.066 4.935 11 11 11 6.066 0 11-4.934 11-11 0-6.065-4.934-11-11-11"
                    fill="#0D0E0F"
                />
            </g>
        </svg>
    );
};
